<template>
  <div>
    <div class="row" style="margin-top: 15px">
      <div class="col-xs-12">
        <div class="form-group">

          <label class="col-sm-2 control-label text-left">Documents</label>
          <div class="col-sm-10">
            <div class="row">
              <span class="text-left col-sm-7 m-t-xs"> Do you have any documents that may help promote your competencies ? </span>
              <div class="col-sm-5 text-center">
                <button type="button" class="btn btn-info btn-outline " @click="modalDocumentAction = 'create'">
                  <i class="fa fa-files-o"></i> Add Document
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <label v-if="errorDocument" class="error m-t-md">{{ errorDocument }}</label>
              </div>
            </div>

          </div>

          <div v-if="documents && documents.length !== 0" class="col-xs-12 m-t" >
            <div v-for="(document, key) in documents" v-if="document" :key="key + '-' + document.documentID" class="col-xs-12 ">

              <document :key="key + '-' + document.documentID" v-model="documents[key]" :removeDocument="removeDocument" />
            </div>
          </div>

        </div>
      </div>
    </div>

    <template v-if="modalDocumentAction">
      <action-modal-document v-model="modalDocumentAction" :user="user" />
    </template>

  </div>
</template>

<script>

import Document from './Document'
import ActionModalDocument from '../../components/modal/ActionModalDocument'
export default {
  components: { Document, ActionModalDocument },
  props: ['user'],
  name: 'DocumentsList',
  data () {
    return {
      documents: null,
      modalDocumentAction: null,
      errorDocument: null
    }
  },
  watch: {
    modalDocumentAction: function (val) {
      if (val == null) {
        this.getResources()
      }
    }
  },
  methods: {
    init: function () {
      this.getResources()
    },
    getResources: function () {
      this.axios.get('/user/' + this.user.id + '/documents')
        .then((response) => {
          this.documents = response.data
        }).catch(function (error) {
        })
    },
    removeDocument: function (event, documentId) {
      event.preventDefault()

      this.axios.delete('/user/' + this.user.id + '/document/' + documentId)
        .then((response) => {
          this.$notify({
            type: 'success',
            title: 'Document has removed',
            placement: 'bottom-right'
          })
          this.init()
        }).catch((error) => {
          this.setErrors(error)
          this.$notify({
            type: 'danger',
            title: 'An error has occurred',
            content: 'Maybe you try to do something wrong ?',
            placement: 'bottom-right'
          })
        })
    }
  },
  beforeMount () {
    this.init()
    this.$eventHub.$on('refreshUserDocumentsList', () => {
      this.init()
    })
  },
  beforeDestroy () {
    this.$eventHub.$off('refreshUserDocumentsList')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/DocumentsList.vue